module.exports = __webpack_public_path__ + "static/05-vegetation-water-indexes-dc97e7cc57c4330776b11ed577399d48.png";